import { render, staticRenderFns } from "./ownerLayout.vue?vue&type=template&id=307a2ac0&scoped=true&"
import script from "./ownerLayout.vue?vue&type=script&lang=js&"
export * from "./ownerLayout.vue?vue&type=script&lang=js&"
import style0 from "./ownerLayout.vue?vue&type=style&index=0&id=307a2ac0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307a2ac0",
  null
  
)

export default component.exports